export default {
    data() {
        return {
            show_edit: false,
            show_pwd: false,
            admin: {
                group: {}
            },
            r: {},
            field: '',
            val: ''
        };
    },
    created() {
        this._admin({
            append: ['group']
        });
    },
    methods: {
        _do_edit() {
            this.$http.post('admin/edit_field', {
                field: this.field,
                val: this.val
            }).then(res => {
                if (res.code) {
                    this.show_edit = false;
                    this._admin({
                        append: ['group']
                    });
                }
            })
        },
        _edit(field) {
            this.field = field;
            this.val = this.admin[field];
            this.show_edit = true;
        },
        _pwd() {
            this.$http
                .post('admin/pwd', {
                    ...this.r
                })
                .then((res) => {
                    if (res.code) {
                        this.show_pwd = false;
                        this._reset('r');
                    }
                });
        },
    },
};